import { Component, ElementRef, ViewChild, OnInit} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {  MatInput } from '@angular/material';
import 'rxjs/add/operator/filter';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { GridOptions } from "ag-grid";
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import * as XLSX from 'xlsx';
declare var $: any;

interface dropdownTemplate {
  name: string;
  value: string;
}
@Component({
  selector: 'd2z-report-per-customer',
  templateUrl: './report-per-customer.component.html',
  styleUrls: ['./report-per-customer.component.css']
})
export class ReportPerCustomerComponent implements OnInit {

 
@ViewChild('frominput', {
  read: MatInput
}) frominput: MatInput;

@ViewChild('toinput', {
  read: MatInput
}) toinput: MatInput;
@ViewChild('myInput') myInputVariable: ElementRef;
  
  errorMsg: string;
  show: Boolean;
  brokerId: String;
  consignmentFlag: Boolean;
  shipmentFlag: Boolean;
  mydate: Date;
  date: String;
  type: String;
  successMsg: String;
  fromDate: String;
  toDate: String;
  airwayBill: String;
  userName: String;
  role_id: String;
  private gridOptionsConsignment: GridOptions;
  private gridOptionsShipment: GridOptions;
  

  private autoGroupColumnDef;
  private rowGroupPanelShow;
  private rowDataConsignment: any[];
  private rowDataConsignmentService: any[];
  private rowDataDeleted: any[];
  private rowDataShipment: any[];
  private rowDataConsignment1: any[];
   private rowDataShipment1: any[];
  private defaultColDef;
  public brokerDataList = [];

  exportTypeDropdown: dropdownTemplate[]; 
   exportTypeDropdown1: dropdownTemplate[]; 
    TypeDropdown: dropdownTemplate[];  
  selectedExportType: dropdownTemplate;
   selectedExportType1: dropdownTemplate;
     selectedType: dropdownTemplate;
  shipmentAllocateForm: FormGroup;
  exportFileType: String;
  exportFileType1: String;
    articleData = [];
     barcodeData=[];
      refData=[];
      outputData  =[];
  file:File;
   arrayBuffer:any;
   Type1: String;
  system: String;
  constructor(
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    public consignmenrServices: ConsigmentUploadService
  ) {
    this.show = false;
    this.consignmentFlag = true;
    this.shipmentAllocateForm = new FormGroup({
      shipmentNumber: new FormControl()
    });
   
    this.autoGroupColumnDef = {
      headerCheckboxSelection: true,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true }
    };      
    this.rowGroupPanelShow = "always";
    this.defaultColDef = {
      editable: true
    };

    // This grid is for Consignment Items
    this.gridOptionsConsignment = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptionsConsignment.columnDefs = [
      {
        headerName: "Broker Name",
        field: "broker_name",
        width: 200,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      },
      {
        headerName: "Article ID",
        field: "articleID",
        width: 200
      },
      {
        headerName: "Ref No.",
        field: "reference_number",
        width: 200
      },
      {
        headerName: "Customer Reference",
        field: "customerReference",
        width: 200
      },
      {
        headerName: "Postcode",
        field: "consignee_Postcode",
        width: 150
      },
       {
        headerName: "Weight",
        field: "weight",
        width: 200
      },
       {
        headerName: "Service Type",
        field: "serviceType",
        width: 200
      },
      {
        headerName: "Carrier",
        field: "carrier",
        width: 200
      },
      {
        headerName: "Shipment Number",
        field: "manifest",
        width: 200
      },
       {
        headerName: "Consignment Created Date",
        field: "dat",
        width: 200
      },
      {
        headerName: "Value",
        field: "value",
        width: 200
      },
      {
        headerName: "Del Name",
        field: "consignee_name",
        width: 200
      },
       {
        headerName: "DelAddr1",
        field: "consignee_addr1",
        width: 200
      },
      {
        headerName: "DelAddr2",
        field: "consignee_addr2",
        width: 200
      },
      {
        headerName: "Suburb",
        field: "consignee_Suburb",
        width: 200
      },
      {
        headerName: "State",
        field: "consignee_State",
        width: 200
      },
      {
        headerName: "Product Description",
        field: "product_Description",
        width: 400
      }

    ];
    this.gridOptionsShipment = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptionsShipment.columnDefs = [
      {
        headerName: "Broker Name",
        field: "broker_name",
        width: 200,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      },
      {
        headerName: "Article ID",
        field: "articleID",
        width: 200
      },
      {
        headerName: "Ref No.",
        field: "reference_number",
        width: 200
      },
      {
        headerName: "Customer Reference",
        field: "customerReference",
        width: 200
      },
      {
        headerName: "Postcode",
        field: "consignee_Postcode",
        width: 150
      },
       {
        headerName: "Weight",
        field: "weight",
        width: 200
      },
       {
        headerName: "Service Type",
        field: "serviceType",
        width: 200
      },
      {
        headerName: "Carrier",
        field: "carrier",
        width: 200
      },
      {
        headerName: "Shipment Number",
        field: "manifest",
        width: 200
      },
       {
        headerName: "Shipment Allocated Date",
        field: "dat",
        width: 200
      },
      {
        headerName: "Value",
        field: "value",
        width: 200
      },
      {
        headerName: "Del Name",
        field: "consignee_name",
        width: 200
      },
       {
        headerName: "DelAddr1",
        field: "consignee_addr1",
        width: 200
      },
      {
        headerName: "DelAddr2",
        field: "consignee_addr2",
        width: 200
      },
      {
        headerName: "Suburb",
        field: "consignee_Suburb",
        width: 200
      },
      {
        headerName: "State",
        field: "consignee_State",
        width: 200
      },
      {
        headerName: "Product Description",
        field: "product_Description",
        width: 400
      }

    ];
  
  }

  ngOnInit() {
    this.type = "consignmentCreated";
    this.brokerDataList = [];
    this.spinner.show();
    this.consignmenrServices.brokerlist((resp) => {
        this.spinner.hide();
        let name = 'name';
        let value = 'value';
          for (var data in resp) {
            var dataValObj = resp[data];
            var brokerObj = (
              brokerObj={}, 
              brokerObj[name]= dataValObj.brokerUserName.name != undefined ? dataValObj.brokerUserName.name : '', brokerObj,
              brokerObj[value]= dataValObj.userId != undefined ? dataValObj.userId : '', brokerObj
            );
            this.brokerDataList.push(brokerObj);
          };
          console.log(this.brokerDataList);
    });  };

  getLoginDetails(){
    if(this.consignmenrServices.userMessage != undefined){
      this.userName = this.consignmenrServices.userMessage.userName;
      this.role_id = this.consignmenrServices.userMessage.role_Id;
    }
  };

 onBrokerChange(event){
  this.brokerId  = event.value.name;
  console.log(this.brokerId);
 }
  FromDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.fromDate = [ date.getFullYear(), mnth, day ].join("-");
  };

  ToDateChange(event){
    var str = event.target.value;
    var date = new Date(str),
          mnth = ("0" + (date.getMonth()+1)).slice(-2),
          day  = ("0" + date.getDate()).slice(-2);
     this.toDate = [ date.getFullYear(), mnth, day ].join("-");
  };


  downloadExportedData(){
   var consignmentSelectedRows = this.gridOptionsConsignment.api.getSelectedRows();
  
    if(consignmentSelectedRows.length > 0 ){
        var currentTime = new Date();
        var consignmentList = [];
        var fileName = '';
            fileName = "Export-Consignment"+"-"+currentTime.toLocaleDateString();
          var options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true, 
            useBom: true,
            headers: [ 
              "Broker Name",
              "Article ID",
              "Reference Number",
              "Customer Reference",
              "PostCode",
              "Weight",
              "ServiceType",
              "Carrier",
              "Shipment Number",
              "Consignment Created Date",
              "value",
              "Del Name",
              "Del Addr1",
              "Del Addr2",
              "Suburb",
              "State",
              "Product Description"
            ]
          };
          let broker_name='broker_name';
          let reference_No = 'reference_No';
          let article_Id = 'article_Id';
          let recipient_Name = 'recipient_Name';
          let address_line_1  = 'address_line_1';
          let address_line_2 = 'address_line_2';
          let suburb = 'suburb';
          let state = 'state';
          let postCode = 'postCode';
          let invoice_value = 'invoice_value';
          let goods_Description = 'goods_Description';
          let total_Weight = 'total_Weight';
          let dat ='dat';
          let servicetype = 'servicetype';
          let shipmentNumber = 'shipmentNumber';
          let carrier = 'carrier';
          let custRef = 'custRef';

          for (var importVal in consignmentSelectedRows) {
              var adminObj = consignmentSelectedRows[importVal];
              var importObj = (
                  importObj={},
                  importObj[broker_name]= adminObj.broker_name != null ? adminObj.broker_name: '', importObj,                  
                  importObj[article_Id]= adminObj.articleID != null ? adminObj.articleID : '', importObj,
                  importObj[reference_No]= adminObj.reference_number != null ? adminObj.reference_number: '', importObj,
                  importObj[custRef]= adminObj.customerReference != null ? adminObj.customerReference: '', importObj,
                  importObj[postCode]= adminObj.consignee_Postcode != null ? adminObj.consignee_Postcode : '',  importObj,
                  importObj[total_Weight]= adminObj.weight != null ? adminObj.weight : '', importObj,
                  importObj[servicetype]= adminObj.serviceType != null ? adminObj.serviceType : '', importObj,
                  importObj[carrier]= adminObj.carrier != null ? adminObj.carrier : '', importObj,
                  importObj[shipmentNumber]= adminObj.manifest != null ? adminObj.manifest : '', importObj,
                  importObj[dat]= adminObj.dat != null ? adminObj.dat : '', importObj,
                  importObj[invoice_value]= adminObj.value != null ? adminObj.value : '', importObj,
                  importObj[recipient_Name]= adminObj.consignee_name != null ? adminObj.consignee_name : '', importObj,
                  importObj[address_line_1] = adminObj.consignee_addr1 != null ? adminObj.consignee_addr1 : '', importObj,
                  importObj[address_line_2]= adminObj.consignee_addr2 != null ? adminObj.consignee_addr2 : '', importObj,
                  importObj[suburb]= adminObj.consignee_Suburb != null ? adminObj.consignee_Suburb : '', importObj,
                  importObj[state]= adminObj.consignee_State != null ? adminObj.consignee_State : '', importObj,
                  importObj[goods_Description]= adminObj.product_Description != null ? adminObj.product_Description : '', importObj
              );
              consignmentList.push(importObj)
          }
        new Angular2Csv(consignmentList, fileName, options);        
      }else{
      
  this.errorMsg = "**Please select the below records to download the file";
  

      } 
  };
  downloadShipmentData(){
    var consignmentSelectedRows = this.gridOptionsShipment.api.getSelectedRows();
   
     if(consignmentSelectedRows.length > 0 ){
         var currentTime = new Date();
         var consignmentList = [];
         var fileName = '';
             fileName = "Export-Shipment"+"-"+currentTime.toLocaleDateString();
           var options = { 
             fieldSeparator: ',',
             quoteStrings: '"',
             decimalseparator: '.',
             showLabels: true, 
             useBom: true,
             headers: [ 
               "Broker Name",
               "Article ID",
               "Reference Number",
               "Customer Reference",
               "PostCode",
               "Weight",
               "ServiceType",
               "Carrier",
               "Shipment Number",
               "Shipment Allocated Date",
               "value",
               "Del Name",
               "Del Addr1",
               "Del Addr2",
               "Suburb",
               "State",
               "Product Description"
             ]
           };
           let broker_name='broker_name';
           let reference_No = 'reference_No';
           let article_Id = 'article_Id';
           let recipient_Name = 'recipient_Name';
           let address_line_1  = 'address_line_1';
           let address_line_2 = 'address_line_2';
           let suburb = 'suburb';
           let state = 'state';
           let postCode = 'postCode';
           let invoice_value = 'invoice_value';
           let goods_Description = 'goods_Description';
           let total_Weight = 'total_Weight';
           let dat ='dat';
           let servicetype = 'servicetype';
           let shipmentNumber = 'shipmentNumber';
           let custRef = 'custRef';
           let carrier = 'carrier';
           for (var importVal in consignmentSelectedRows) {
               var adminObj = consignmentSelectedRows[importVal];
               var importObj = (
                   importObj={},
                   importObj[broker_name]= adminObj.broker_name != null ? adminObj.broker_name: '', importObj,                  
                   importObj[article_Id]= adminObj.articleID != null ? adminObj.articleID : '', importObj,
                   importObj[reference_No]= adminObj.reference_number != null ? adminObj.reference_number: '', importObj,
                   importObj[custRef]= adminObj.customerReference != null ? adminObj.customerReference: '', importObj,
                   importObj[postCode]= adminObj.consignee_Postcode != null ? adminObj.consignee_Postcode : '',  importObj,
                   importObj[total_Weight]= adminObj.weight != null ? adminObj.weight : '', importObj,
                   importObj[servicetype]= adminObj.serviceType != null ? adminObj.serviceType : '', importObj,
                   importObj[carrier]= adminObj.carrier != null ? adminObj.carrier : '', importObj,
                   importObj[shipmentNumber]= adminObj.manifest != null ? adminObj.manifest : '', importObj,
                   importObj[dat]= adminObj.dat != null ? adminObj.dat : '', importObj,
                   importObj[invoice_value]= adminObj.value != null ? adminObj.value : '', importObj,
                   importObj[recipient_Name]= adminObj.consignee_name != null ? adminObj.consignee_name : '', importObj,
                   importObj[address_line_1] = adminObj.consignee_addr1 != null ? adminObj.consignee_addr1 : '', importObj,
                   importObj[address_line_2]= adminObj.consignee_addr2 != null ? adminObj.consignee_addr2 : '', importObj,
                   importObj[suburb]= adminObj.consignee_Suburb != null ? adminObj.consignee_Suburb : '', importObj,
                   importObj[state]= adminObj.consignee_State != null ? adminObj.consignee_State : '', importObj,
                   importObj[goods_Description]= adminObj.product_Description != null ? adminObj.product_Description : '', importObj
               );
               consignmentList.push(importObj)
           }
         new Angular2Csv(consignmentList, fileName, options);        
       }else{
       
   this.errorMsg = "**Please select the below records to download the file";
   
 
       } 
   };
 
    clearDetails(){

    
this.brokerId = "";
this.airwayBill = "";
       this.type="consignmentCreated";
          this.rowDataConsignment = [];
      this.rowDataShipment = [];
  this.frominput.value = '';
  this.toinput.value = '';
    this.successMsg = null;
    this.errorMsg = null;
   
  };
 

    exportSearch(){
      this.rowDataConsignment = [];
      this.rowDataShipment = [];
    this.errorMsg = null;
    this.successMsg = '';
    if(this.brokerId == undefined || this.brokerId.length<1){
      this.errorMsg = "Please select a Broker!";
    }else if (this.fromDate == undefined || this.toDate == undefined){
      this.errorMsg = 'Please select valid From Date and To Date!';
    }
    if(this.errorMsg == null){
        this.spinner.show();
        var request = {
          "userId": this.brokerId,
          "reportType":this.type,
          "airwayBill":this.airwayBill,
          "fromDate":this.fromDate,
          "toDate":this.toDate
        }
        console.log(request);
        this.trackingDataService.exportCustomerReport(request, (resp) => {
          this.spinner.hide();
          if(resp.status == 400 ){
            this.successMsg = resp.error.errorMessage;
          }
         else{
            this.rowDataConsignment = resp;
          }
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
    }
  };



  onConsignmentChange() {
    var consignmentSelectedRows = this.gridOptionsConsignment.api.getSelectedRows();
    this.errorMsg = null;
  };

  onSelectionChange() {
    var consignmentSelectedRows = this.gridOptionsConsignment.api.getSelectedRows();
    this.errorMsg = null;
  };


  onShipmentChange(){
    var shipmentSelectedRows = this.gridOptionsShipment.api.getSelectedRows();
    this.errorMsg = null;
  }
 
 
}




// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/reports/report-per-customer/report-per-customer.component.ts